const PHONE = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
const MOBILE_PHONE = /^0\d{2,3}-?\d{7,8}$/
const ID_CARD = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
const TEL = /^([0-9]{3,4}-)?[0-9]{7,8}$/;

export const contact = {
    arr: [{
        trigger: "blur",
        validator: (rule, value, cb) => {
            if (MOBILE_PHONE.test(value) || PHONE.test(value)) {
                cb()
            } else {
                cb(new Error('请输入正确的联系方式'))
            }
        }
    }],
    fn(contact) {
        return MOBILE_PHONE.test(contact) || PHONE.test(contact)
    }
}
export const idCard = {
    arr: [{
        trigger: "blur",
        validator: (rule, value, cb) => {
            if (ID_CARD.test(value)) {
                cb()
            } else {
                cb(new Error('身份证输入不合法'))
            }
        }
    }],
    fn(contact) {
        return ID_CARD.test(contact)
    }
}
export function validContact(rule, value, callback) {
    if (PHONE.test(value) || TEL.test(value)) {
        callback();
    }
    callback(new Error('请输入正确的联系方式'))
}